import React, { useEffect, useState, useMemo } from "react";
import { Constants } from "@eagerdog/constants";
import { IScore, IBarnHuntScore } from "@eagerdog/interfaces";

import Dropdown, { IOption } from "src/components/Dropdown/Dropdown";
import StopWatch from "src/components/EnterResults/StopWatch/StopWatch";

interface IProps {
  result: IScore;
  onChange(result: IBarnHuntScore): void;
}

/**
 * Instinct Class Results Form
 * - Pass/Fail/Absent toggle
 * - Optional time (must be <= 1:00 if entered)
 */
const InstinctForm: React.FC<IProps> = (props) => {
  const [time, setTime] = useState<string>("0:00:00");
  const [result, setResult] = useState<IOption>({ id: Constants.score_result_type.qualified, value: "Qualified" });
  const [loaded, setLoaded] = useState<boolean>(false);
  const [hasChanged, setHasChanged] = useState<boolean>(false);

  const resultOptions: IOption[] = useMemo(
    () => [
      { id: Constants.score_result_type.qualified, value: "Pass" },
      { id: Constants.score_result_type.not_qualified, value: "Fail" },
      { id: Constants.score_result_type.absent, value: "Absent" },
    ],
    []
  );

  useEffect(() => {
    if (!loaded) {
      if (props.result && props.result.barn_hunt) {
        const { result_type, time: savedTime } = props.result.barn_hunt;
        for (let ro in resultOptions) {
          if (resultOptions[ro].id === result_type) {
            setResult(resultOptions[ro]);
            break;
          }
        }

        if (savedTime) {
          setTime(savedTime);
        }
      }
      setLoaded(true);
    }
  }, [loaded, props.result, resultOptions]);

  useEffect(() => {
    if (hasChanged) {
      // Convert from M:SS:TT to MM:SS.TT format for storage
      let resultTime: string | undefined;
      const parts = time.split(":");
      if (parts.length === 3 && (parts[0] !== "0" || parts[1] !== "00")) {
        resultTime = `${parts[0]}:${parts[1]}.${parts[2]}`;
      }

      props.onChange({
        result_type: result.id,
        time: resultTime,
      });

      setHasChanged(false);
    }
  }, [hasChanged, time, props, result.id]);

  const handleTimeChange = (value: string) => {
    setTime(value);
    setHasChanged(true);
  };

  const handleResultChange = (e: any, value: IOption) => {
    setResult(value);
    setHasChanged(true);
  };

  return (
    <div className="BarnHuntResults">
      <div className="instruction-section">
        <p className="instruction-text">
          <strong>Instinct Class:</strong> Select Pass/Fail and optionally enter time (max 1:00).
        </p>
      </div>

      <div className="form-row">
        <Dropdown
          value={result}
          label="Result"
          onChange={handleResultChange}
          options={resultOptions}
          placeholder=""
        />
      </div>

      <div className="form-row">
        <StopWatch
          time={time}
          onChange={handleTimeChange}
          label="Time (optional, max 1:00)"
        />
      </div>
    </div>
  );
};

export default InstinctForm;

